import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";
import { useDispatch } from "react-redux";
import { validateGoogleAdsConfig } from "../../../../slices/veloxity/integration/googleAdsValidationSlice";
import { showErrorAlert, showLoadingAlert , showSuccessAlert } from "../../../../components/custom/sweetalertHelper";

const GoogleAdsModal = ({ isOpen, toggle, currentConfig, onSubmit }) => {
    const [formData, setFormData] = useState({});
    const [isVerified, setIsVerified] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (currentConfig) {
            setFormData({
                name: currentConfig.name,
                expireDate: currentConfig.expireDate,
                clientId: currentConfig.metaData.clientId || '',
                clientSecret: currentConfig.metaData.clientSecret || '',
                developerToken: currentConfig.metaData.developerToken || '',
                refreshToken: currentConfig.metaData.refreshToken || '',
                mccCustomerId: currentConfig.metaData.mccCustomerId || '',
            });
            setIsVerified(true); // Düzenleme modunda doğrulanmış olarak varsayabiliriz
        } else {
            resetFormData();
        }
    }, [currentConfig]);

    const resetFormData = () => {
        setFormData({
            name: '',
            expireDate: '',
            clientId: '',
            clientSecret: '',
            developerToken: '',
            refreshToken: '',
            mccCustomerId: ''
        });
        setIsVerified(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setIsVerified(false); 
    };

    const handleVerify = async () => {
        try {
            showLoadingAlert("Verifying", "Please wait while we verify the Google Ads configuration...");
            const googleRequestBody = {
                name: formData.name,
                expireDate: formData.expireDate,
                config: {
                    clientId: formData.clientId,
                    clientSecret: formData.clientSecret,
                    developerToken: formData.developerToken,
                    refreshToken: formData.refreshToken,
                    mccCustomerId: formData.mccCustomerId,
                },
            };
            const result = await dispatch(validateGoogleAdsConfig(googleRequestBody)).unwrap();
            if (result) {
                setIsVerified(true);
                showSuccessAlert("Verification successful", "Google Ads verification was successful.");
            }else{
                showErrorAlert("Verification failed", "Please check the input values and try again.");
            }
        } catch (error) {
            showErrorAlert("Verification failed", "Please check the input values and try again.");
        }
    };

    const handleSubmit = () => {
        if (isVerified) {
            onSubmit(formData);
            toggle(); 
        } 
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{currentConfig ? 'Edit Google Ads Account' : 'Create Google Ads Account'}</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="name">Name</Label>
                    <Input type="text" name="name" id="name" value={formData.name} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="expireDate">Expire Date</Label>
                    <Input type="date" name="expireDate" id="expireDate" value={formData.expireDate} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="clientId">Client ID</Label>
                    <Input type="text" name="clientId" id="clientId" value={formData.clientId} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="clientSecret">Client Secret</Label>
                    <Input type="text" name="clientSecret" id="clientSecret" value={formData.clientSecret} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="developerToken">Developer Token</Label>
                    <Input type="text" name="developerToken" id="developerToken" value={formData.developerToken} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="refreshToken">Refresh Token</Label>
                    <Input type="text" name="refreshToken" id="refreshToken" value={formData.refreshToken} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="mccCustomerId">MCC Customer ID</Label>
                    <Input type="text" name="mccCustomerId" id="mccCustomerId" value={formData.mccCustomerId} onChange={handleInputChange} />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleVerify}>Verify</Button>
                <Button color="success" onClick={handleSubmit} disabled={!isVerified}>Submit</Button>
            </ModalFooter>
        </Modal>
    );
};

export default GoogleAdsModal;
